import Modal from "../../utils/modal"

const InfosModal = ({ close, model }) => {
    return (
        <Modal>
            <div className="relative">
                <div className="absolute top-0 right-0 text-primary font-bold text-lg cursor-pointer" onClick={close}>X</div>
                <h1 className="text-center text-primary font-bold text-lg">Informações do modelo</h1>
                <div className="my-4 border-t border-b border-[#777]">
                    <div className="flex">
                        <p className="text-primary w-32">Nome:</p>
                        <p className="text-center flex-1">{model?.name}</p>
                    </div>
                    <div className="flex">
                        <p className="text-primary w-32">Jogo:</p>
                        <p className="text-center flex-1">{model?.game}</p>
                    </div>
                    <div className="flex">
                        <p className="text-primary w-32">Edição:</p>
                        <p className="text-center flex-1">{model?.edition}</p>
                    </div>
                    <div className="flex">
                        <p className="text-primary w-32">Raridade:</p>
                        <p className="text-center flex-1">{model?.rarity}</p>
                    </div>
                    <div className="flex">
                        <p className="text-primary w-32">Ano:</p>
                        <p className="text-center flex-1">{model?.year}</p>
                    </div>
                    <div className="flex">
                        <p className="text-primary w-32">Idioma:</p>
                        <p className="text-center flex-1">{model?.language}</p>
                    </div>
                    <div className="flex">
                        <p className="text-primary w-32">Numeração:</p>
                        <p className="text-center flex-1">{model?.numbering}</p>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default InfosModal;
